const HERO_SLIDER_CLASS = 'hero-slider'
const HERO_SLIDER_SLIDES_CLASS = 'hero-slider__slides'

const HERO_SLIDER_LIST_CLASS = 'hero-slider__list'
const HERO_SLIDER_LIST_ITEM_CLASS = 'hero-slider__list-item'

const HERO_SLIDER_LIST_ITEM_ACTIVE_CLASS = 'hero-slider__list-item--active'
const HERO_SLIDER_LIST_ITEM_NAVIGATION_TITLE_CLASS = 'hero-slider__list-item__navigation-title'

const HERO_SLIDER_SLIDE_ACTIVE_CLASS = 'hero-slider__slides-slide--active'

const HERO_SLIDER_NEXT_BUTTON_CLASS = 'hero-slider__slides-controls__next'
const HERO_SLIDER_PREV_BUTTON_CLASS = 'hero-slider__slides-controls__prev'

const HERO_SLIDER_PAGINATION_BULLET_CLASS = 'hero-slider__slides-pagination-bullet'
const HERO_SLIDER_PAGINATION_BULLET_ACTIVE_CLASS = 'hero-slider__slides-pagination-bullet--active'

export {
  HERO_SLIDER_CLASS,
  HERO_SLIDER_SLIDES_CLASS,
  HERO_SLIDER_SLIDE_ACTIVE_CLASS,
  HERO_SLIDER_LIST_CLASS,
  HERO_SLIDER_LIST_ITEM_CLASS,
  HERO_SLIDER_LIST_ITEM_ACTIVE_CLASS,
  HERO_SLIDER_LIST_ITEM_NAVIGATION_TITLE_CLASS,
  HERO_SLIDER_NEXT_BUTTON_CLASS,
  HERO_SLIDER_PREV_BUTTON_CLASS,
  HERO_SLIDER_PAGINATION_BULLET_ACTIVE_CLASS,
  HERO_SLIDER_PAGINATION_BULLET_CLASS,
}
